import { Component, effect, signal } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import { Router } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import { manualOrgKeyRoute, scanQrRoute} from '../../route-names';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { OrganizationItemComponent } from './organization-item/organizations-item.component';
import { ElectorDataService } from 'src/app/Services/elector-data.service';
import { CustomerOidProfileSnapshot } from 'src/app/backend-types/misc-types';
import { isMobile } from 'src/app/Services/utils';

@Component({
    selector: 'app-organizations-panel',
    imports: [MatExpansionModule, MatIconModule, OrganizationItemComponent],
    templateUrl: './organizations-panel.component.html',
    styleUrl: './organizations-panel.component.scss'
})
export class OrganizationsPanelComponent {
  organizationsCount: number = 0;
  orgOpenState = signal(false);
  organizations: CustomerOidProfileSnapshot[] = [];
  
  constructor(
    private readonly router: Router,
    private announcer: LiveAnnouncer,
    private electorService: ElectorDataService
  ) {
    effect(()=> {
      this.organizations = this.electorService.orgVerifications();
      this.organizationsCount = this.organizations.length;
    })
  }

  onPanelOpen(): void {
    this.orgOpenState.set(true);
  }

  onPanelClose(): void {
    this.orgOpenState.set(false);
    this.announcer.announce('Organization Verifications' , "assertive")
  }
  get openDescription(): string {
    if(isMobile()){
      return "";
    } else {
      return $localize`Organization Verifications`;
    }
  }

  get closeDescription(): string {
    if(isMobile()){
      return "";
    } else {
      return $localize`Click here to view your organization verifications.`;
    }
  }

  get OrgOpenStateDescription(): string {
    return $localize`Click here to view your organization verifications.`;
  }

  scanQR() {
    this.router.navigate(scanQrRoute)
  }
  orgKeyManual(){
    this.router.navigate(manualOrgKeyRoute)
  }
}
